var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastTower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mast Color_White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.804 0.250024H13.6692L13.704 0.260305C13.8192 0.294413 13.9016 0.37348 13.9572 0.448473C14.0142 0.525355 14.0576 0.617179 14.0903 0.712151C14.1554 0.901386 14.1898 1.1365 14.187 1.38105C14.3654 9.11693 14.5528 16.8528 14.7493 24.5887C14.757 24.8788 14.6972 25.1514 14.5796 25.3608C14.4646 25.5658 14.2667 25.75 13.9959 25.75H12.5035C12.2305 25.75 12.0363 25.5631 11.9239 25.3591C11.8093 25.151 11.75 24.8809 11.75 24.595V24.5892C11.8126 21.8922 11.8976 18.2955 11.9816 14.74C12.1374 8.14926 12.2898 1.69972 12.2898 1.38238C12.2898 1.11736 12.3237 0.881036 12.3899 0.69454C12.4509 0.52269 12.5634 0.328475 12.7662 0.262339L12.804 0.250024ZM12.9162 0.750024C12.9035 0.76669 12.8831 0.7997 12.8611 0.861774C12.8195 0.978945 12.7898 1.15498 12.7898 1.38238C12.7898 1.70572 12.6363 8.20053 12.48 14.814C12.3965 18.3496 12.3121 21.9192 12.25 24.5978C12.2504 24.8198 12.2976 25.0011 12.3619 25.1178C12.4286 25.239 12.4862 25.25 12.5035 25.25H13.9959C14.0154 25.25 14.0761 25.2363 14.1436 25.116C14.2086 25.0003 14.2554 24.8206 14.2495 24.6017C14.0529 16.864 13.8654 9.12589 13.687 1.38814L13.6868 1.37904C13.6895 1.17894 13.6609 1.00098 13.6175 0.874985C13.5969 0.81501 13.5755 0.774329 13.5583 0.750024H12.9162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7881 0.150024H13.6837L13.7324 0.164418C13.876 0.206926 13.9747 0.304153 14.0375 0.388929C14.1024 0.476434 14.1499 0.578263 14.1848 0.679585C14.2543 0.881174 14.2897 1.12734 14.287 1.38045C14.4654 9.11565 14.6528 16.8508 14.8493 24.586M12.7881 0.150024L12.7352 0.167265ZM12.8199 0.350024L12.7972 0.357413C12.6404 0.408561 12.5424 0.563826 12.4841 0.727987C12.4229 0.900618 12.3898 1.12489 12.3898 1.38238C12.3898 1.7009 12.2377 8.13714 12.0822 14.7179L12.0687 15.2894C11.9889 18.6638 11.9093 22.0318 11.85 24.5904V24.595C11.85 24.8684 11.9069 25.1209 12.0115 25.3108C12.1151 25.4989 12.2821 25.65 12.5035 25.65H13.9959C14.216 25.65 14.3866 25.5004 14.4924 25.3119C14.5995 25.1212 14.6567 24.8672 14.6494 24.5914C14.4528 16.8554 14.2654 9.11931 14.087 1.38335L14.0869 1.3799C14.0896 1.14453 14.0565 0.921135 13.9957 0.744718C13.9652 0.656094 13.926 0.574276 13.8769 0.508017C13.8285 0.442808 13.7624 0.3819 13.6756 0.356193L13.6547 0.350024H12.8199ZM12.8667 0.650024H13.6101L13.64 0.692318C13.664 0.726425 13.6893 0.776264 13.7121 0.842418C13.7598 0.980949 13.7894 1.17 13.7868 1.37853L13.787 1.38584C13.9654 9.12346 14.1529 16.8614 14.3495 24.5991M12.9735 0.850024C12.968 0.861899 12.9619 0.876776 12.9553 0.895221C12.9187 0.998526 12.8898 1.16251 12.8898 1.38238C12.8898 1.7069 12.7366 8.18858 12.5806 14.7923L12.58 14.8164C12.4965 18.3515 12.4121 21.9204 12.35 24.5989C12.3505 24.8078 12.3952 24.9711 12.4494 25.0695C12.4778 25.1211 12.5 25.1412 12.5096 25.1482L12.5124 25.15H13.9882C13.9968 25.1456 14.0223 25.128 14.0564 25.0671C14.1109 24.9701 14.155 24.809 14.1495 24.6044C13.953 16.8666 13.7655 9.12828 13.587 1.39045L13.5867 1.3777C13.5893 1.18676 13.5619 1.02061 13.523 0.907552C13.515 0.884385 13.5072 0.865349 13.5001 0.850024H12.9735ZM13.9851 25.1513L13.9863 25.1509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7 16C4.7 15.8343 4.83431 15.7 5 15.7H21C21.1657 15.7 21.3 15.8343 21.3 16C21.3 16.1657 21.1657 16.3 21 16.3H5C4.83431 16.3 4.7 16.1657 4.7 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 12.7V14.2H6.16667V15.2H4.83333V14.2H5.16667V12.7H5.83333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 11.7C7.70152 11.7 8 11.9985 8 12.3667C8 12.7349 7.70152 13.0334 7.33333 13.0334C7.08672 13.0334 6.87138 12.8995 6.75606 12.7004L4.24413 12.7C4.12886 12.8993 3.91342 13.0334 3.66667 13.0334C3.29848 13.0334 3 12.7349 3 12.3667C3 11.9985 3.29848 11.7 3.66667 11.7C3.91328 11.7 4.12862 11.8339 4.24394 12.033L6.75587 12.0333C6.87114 11.8341 7.08658 11.7 7.33333 11.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8333 12.7V14.2H21.1667V15.2H19.8333V14.2H20.1667V12.7H20.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3333 11.7C22.7015 11.7 23 11.9985 23 12.3667C23 12.7349 22.7015 13.0334 22.3333 13.0334C22.0867 13.0334 21.8714 12.8995 21.7561 12.7004L19.2441 12.7C19.1289 12.8993 18.9134 13.0334 18.6667 13.0334C18.2985 13.0334 18 12.7349 18 12.3667C18 11.9985 18.2985 11.7 18.6667 11.7C18.9133 11.7 19.1286 11.8339 19.2439 12.033L21.7559 12.0333C21.8711 11.8341 22.0866 11.7 22.3333 11.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7 7.00002C5.7 6.83434 5.83431 6.70002 6 6.70002H20C20.1657 6.70002 20.3 6.83434 20.3 7.00002C20.3 7.16571 20.1657 7.30002 20 7.30002H6C5.83431 7.30002 5.7 7.16571 5.7 7.00002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83333 3.70002V5.20002H7.16667V6.20002H5.83333V5.20002H6.16667V3.70002H6.83333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 2.70002C8.70152 2.70002 9 2.9985 9 3.36669C9 3.73488 8.70152 4.03336 8.33333 4.03336C8.08672 4.03336 7.87138 3.89945 7.75606 3.70038L5.24413 3.70005C5.12886 3.8993 4.91342 4.03336 4.66667 4.03336C4.29848 4.03336 4 3.73488 4 3.36669C4 2.9985 4.29848 2.70002 4.66667 2.70002C4.91328 2.70002 5.12862 2.83393 5.24394 3.033L7.75587 3.03333C7.87114 2.83408 8.08658 2.70002 8.33333 2.70002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8333 3.70002V5.20002H20.1667V6.20002H18.8333V5.20002H19.1667V3.70002H19.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 2.70002C21.7015 2.70002 22 2.9985 22 3.36669C22 3.73488 21.7015 4.03336 21.3333 4.03336C21.0867 4.03336 20.8714 3.89945 20.7561 3.70038L18.2441 3.70005C18.1289 3.8993 17.9134 4.03336 17.6667 4.03336C17.2985 4.03336 17 3.73488 17 3.36669C17 2.9985 17.2985 2.70002 17.6667 2.70002C17.9133 2.70002 18.1286 2.83393 18.2439 3.033L20.7559 3.03333C20.8711 2.83408 21.0866 2.70002 21.3333 2.70002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.915 21.5056L14.288 17.6732L14.4581 17.7785L12.0851 21.6109L11.915 21.5056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2556 17.5355L14.5957 17.7461L12.1175 21.7486L11.7774 21.538L14.2556 17.5355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2617 13.6572L14.0877 9.79739L14.2685 9.88291L12.4425 13.7428L12.2617 13.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.04 9.66423L14.4016 9.83528L12.4901 13.8759L12.1286 13.7049L14.04 9.66423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0836 21.5037L14.4566 25.147L14.289 25.2561L11.916 21.6128L12.0836 21.5037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1128 21.3653L14.595 25.1762L14.2598 25.3945L11.7776 21.5836L12.1128 21.3653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4414 13.6552L14.4624 17.681L14.2836 17.7707L12.2627 13.7449L12.4414 13.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4859 13.5209L14.5966 17.7255L14.2391 17.9049L12.1285 13.7004L12.4859 13.5209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7196 5.22871L14.0314 1.41493L13.8423 1.34988L12.5083 5.22825L14.0833 9.87231L14.2727 9.80808L12.7196 5.22871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7803 1.22279L14.1585 1.35289L12.8253 5.22894L14.3995 9.87066L14.0207 9.99913L12.4026 5.22802L13.7803 1.22279Z",
    fill: "white"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastTower);
export default __webpack_public_path__ + "static/media/MastTower.81f502fb.svg";
export { ForwardRef as ReactComponent };